import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';
import { SetupStoreId } from '@/enum';
import { fetchGetAllRoles } from '@/service/api';
import { useAuthStore } from '../auth';

export const useRoleStore = defineStore(SetupStoreId.Role, () => {
  const roleList = reactive<Api.SystemManage.AllRole[]>([]);
  const userStore = useAuthStore();

  const roleMap = computed(() => {
    return roleList.reduce(
      (acc, role) => {
        acc[role.code] = role;
        return acc;
      },
      {} as Record<string, Api.SystemManage.AllRole>
    );
  });

  const getRoleList = async () => {
    try {
      const res: any = await fetchGetAllRoles();
      if (res.code === 0) {
        Object.assign(roleList, res?.data || []);
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  async function initRoleList() {
    if (userStore?.token) {
      await getRoleList();
    }
  }

  return {
    roleList,
    roleMap,
    initRoleList
  };
});
